import { getTenantId, setLocalTenantId } from "@/lib/storeManager";
import { createContext, ReactNode, useEffect, useState } from "react";

interface TenantContextType {
  tenantId: string | null;
  setTenantId: (id: string) => void;
  clearTenantId: () => void;
}

const TenantContext = createContext<TenantContextType | undefined>(undefined);

interface TenantProviderProps {
  children: ReactNode;
}

export const TenantProvider: React.FC<TenantProviderProps> = ({ children }) => {
  const [tenantId, setTenantIdState] = useState<string | null>(() => {
    // Initialize from ENV variable VITE_X_TENANTID, fall back to stored value
    return import.meta.env.VITE_X_TENANTID || getTenantId() || null;
  });

  const setTenantIdHandler = (id: string) => {
    setLocalTenantId(id);
    setTenantIdState(id);
  };

  const clearTenantId = () => {
    localStorage.removeItem("tenantId");
    setTenantIdState(null);
  };

  return (
    <TenantContext.Provider
      value={{
        tenantId,
        setTenantId: setTenantIdHandler,
        clearTenantId,
      }}
    >
      {children}
    </TenantContext.Provider>
  );
};

// Export the context for use in other files
export { TenantContext };
